import { AutomationsStatusCounts } from '@/store/automations/types';
import { AutomationsHeaders } from '@/services/dictionaries/Headers';

export const extractAutomationsStatusCounts = (headers: Record<string, React.ReactText>): AutomationsStatusCounts => ({
        total: Number(headers[AutomationsHeaders.TotalCount]) || 0,
        active: Number(headers[AutomationsHeaders.ActiveCount]) || 0,
        invalid: Number(headers[AutomationsHeaders.InvalidCount]) || 0,
        paused: Number(headers[AutomationsHeaders.PausedCount]) || 0,
        draft: Number(headers[AutomationsHeaders.DraftCount]) || 0,
    });
